import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';

import { ArtworkContext } from 'contexts/ArtworkContext';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { TemplateCards } from 'modules/artwork/template/TemplateCards';

export const ArtworkLayouts = (props) => {
  const { close } = props;
  const [currentLayout, setCurrentLayout] = useState(null);

  const { callbacks, documentRendered } = useContext(ArtworkContext);
  const { handleSelectLayout } = callbacks;

  const selectedTemplate = useSelector((state) => state.artworks.selectedTemplate);

  return (
    <DrawerContent>
      <DrawerContent.Header
        title="Select a Layout"
        loading={!documentRendered}
        hideClose
      />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: 0.1,
            }}
          >
            <TemplateCards
              templates={selectedTemplate?.layouts}
              selectedTemplate={currentLayout}
              onClick={setCurrentLayout}
            />
          </Box>
        </DrawerContent.Content>
        <DrawerContent.ActionButtons
          submitButtonText="Create"
          disabled={!documentRendered || !currentLayout}
          submit={() => handleSelectLayout(currentLayout, close)}
          hideClose
        />
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};

export default ArtworkLayouts;
